import React, { useState } from 'react';
import { Button, Paper, Typography, TextField } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { requestCode, requestAddDevice } from '../../../actions/authentication';

function TwoFactor({ classes, setTwoFactor, email }) {
  const dispatch = useDispatch();
  const [sendCode, setSendCode] = useState(true);
  const [enterCode, setEnterCode] = useState(false);
  const [code, setCode] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if(enterCode == true)
    {
      dispatch(requestAddDevice({ email, code })).then((res) => {
       if (res.error_code == null)
       {
         setTwoFactor(false);
       }
    });
    }
    else
    {
      dispatch(requestCode({ email })).then((res) => {
       if (res.error_code == null)
       {
         setEnterCode(true);
         setSendCode(false);
       }
    });
    }
  };

  return (
              <Paper className={classes.paper} elevation={0}>
                  <form onSubmit={handleSubmit}>
                      <Typography component="h1" variant="h5" className={classes.twoFactorHeader}>
                          {'Two Factor Authentication'}
                      </Typography>
                      <p>
                        {sendCode? 'Send code to email or phone' : 'Enter code from the email or phone'}
                      </p>
                      {enterCode && (<TextField
                        required
                        fullWidth
                        name="code"
                        variant="outlined"
                        placeholder=""
                        type="name"
                        value={code}
                        className={classes.fieldTwoFactor}
                        onChange={e => setCode(e.target.value)}
                      />)}
                      <Button fullWidth className={classes.submitButton} type="submit">
                        {sendCode? 'Send Code' : 'Enter Code'}
                      </Button>
                  </form>
              </Paper>
  );
}

export default TwoFactor;
